$(window).scroll(function() {
    var topper = $(document).scrollTop();
    var offsetter = 0;

    if ($('.compare-table-key-offsetter').length) {
        offsetter = $('.compare-table-key-offsetter').offset().top -75;
    }

    $('.call-us').hover(function(){
      $(this).css('width', 99).html('888-670-4887');
    });

    // if(topper > offsetter) {
    //   $('.compare-table-key')
    //     .css({
    //       'position': 'fixed',
    //       'top': '66px',
    //       'height':66,
    //       'margin-left': '285px',
    //       'overflow': 'hidden',
    //       'opacity': 0.9
    //       })
    //     .addClass('js-compare-table-stick');
    //   // If distance from top is less than our offset
    // } else {
    //   $('.compare-table-key').attr('style', '').removeClass('js-compare-table-stick');
    // }
});

jQuery(document).ready(function($) {
    //Match the height of grid columns
    $('.equalize-heights .height-target').matchHeight({
        property: 'min-height'
    });
});

$(window).load(function(){
    $('.more-industries-toggle').click(function(e) {
        e.preventDefault();

        $(this).parent().prev().fadeIn(800);
        $(this).hide();
    });

    $('.more-icons-toggle').click(function(e) {
        e.preventDefault();

        var $moreIcons = $(this).parents('.limit').next();

        if ($moreIcons.is(":visible")) {
            $(this).html('Show more');
        } else {
            $(this).html('Show less');
        }

        $moreIcons.slideToggle();
    });

  //var $compareScrollTop = $('#compare').offset().top - 40;

  // Adjust tooltip position depending on height of specific div
  $('.col1').mouseenter(function(){
    var $colHeight = $(this).height();

    if ($colHeight > 50) {
      $('.compare-table-tooltip-txt').css('bottom',"70px");
    }

    else if ($colHeight > 25 && $colHeight < 50) {
      $('.compare-table-tooltip-txt').css('bottom',"48px");
    }

    else {
      $('.compare-table-tooltip-txt').css('bottom',"32px");
    }
  });

  //adjust expand button depending on height of FAQ div
  $('.faq-contain').each(function(i, obj) {
    var $faqContain = $(this).height();

    if ($faqContain > 99){
      $(this).find(".exp-btn").css('margin-top',"-62px");
    }

    if ($faqContain > 79 && $faqContain < 99){
      $(this).find(".exp-btn").css('margin-top',"-54px");
    }

    if ($faqContain > 59 && $faqContain < 79){
      $(this).find(".exp-btn").css('margin-top',"-41px");
    }

    if ($faqContain > 49 && $faqContain < 59){
      $(this).find(".exp-btn").css('margin-top',"-41px");
    }

    else if ($faqContain > 22 && $faqContain < 49) {
      $(this).find(".exp-btn").css('margin-top',"-32px");
    }
  });

  // expand faq answer
  $('.faq-contain').click(function(){
    var $par = $(this).closest("li");

    $(this).toggleClass("faq-contain-grey");
    $par.find(".faq-p").slideToggle("fast","linear");


    setTimeout(function() {
      $par.find(".exp-plus").toggle();
      $par.find(".exp-mns").toggle();
    }, 307);
  });

    var windowHeight = $(window).height();

    $(window).scroll(function() {
        var topper = $(document).scrollTop();

        // console.log(topper);

        if (topper < (windowHeight * 0.3)) {
            $('.ub-emb-bar .ub-emb-bar-frame').addClass('hide');
        } else if ($('.ub-emb-bar .ub-emb-bar-frame').hasClass('hide')) {
            $('.ub-emb-bar .ub-emb-bar-frame').removeClass('hide');
        }
    });

    $('.toggle-trigger').click(function() {
        var $target = $($(this).data('target'));
        var $trigger = $(this);

        if ($target.hasClass('open')) {
            $target.slideUp(500).removeClass('open');
            $('span', $trigger).html($trigger.data('expand-label'));
        } else {
            $target.slideDown(500).addClass('open').removeClass('hidden');
            $('span', $trigger).html($trigger.data('contract-label'));

        }
    });

  // animate expand button
  $('.faq-contain').toggle(function() {
    var $par = $(this).closest("li");

    $par.find('.exp-plus').animate({  borderSpacing: -90 }, {
      step: function(now,fx) {
        $(this).css('-webkit-transform','rotate('+now+'deg)');
        $(this).css('-moz-transform','rotate('+now+'deg)');
        $(this).css('transform','rotate('+now+'deg)');
      },
    duration:'medium'
    },'linear');
   },
  function() {
    var $par = $(this).closest("li");

    $par.find('.exp-mns').animate({  borderSpacing: -180 }, {
      step: function(now,fx) {
        $(this).css('-webkit-transform','rotate('+now+'deg)');
        $(this).css('-moz-transform','rotate('+now+'deg)');
        $(this).css('transform','rotate('+now+'deg)');
      },
    duration:'medium'
    },'linear');
  });

});
